import {AfterContentInit, Component, DoCheck, Input, ViewChild} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { HoverInfoComponent } from '@caslink/common-client/ng-app/hoverInfo/HoverInfoComponent';
import { DeviceInformation } from '../shared/models/device-information';
import { DynamicComponentService } from './dynamic-component.service';
import { IControlInput, IDeviceNode} from '../shared/models/device';
import { DeviceInputHostDirective } from './device-input-host.directive';
import { IDeviceInputComponent } from './device-input.interface';

interface DynamicInputComponent {
    deviceInfo;
    groupSections;
    displayCount;
    deviceInputForm;
    setDeviceInfo: (deviceInfo: DeviceInformation) => void;
    hideTitle;
}

// Template based directive used to compile the template associated with
// a given device input.
@Component({
    selector: 'dl-device-input',
    template: `
        <div>
            <ng-template dl-device-input-host></ng-template>
        </div>`
})
export class DeviceInputComponent implements AfterContentInit, DoCheck {
    public static $name: string = 'deviceInput';

    @Input() public deviceInputForm: FormGroup;

    /** This is an optional override */
    @Input() public deviceInputTemplate: string;

    @Input() public deviceInput: IControlInput;

    @Input() public deviceInfo: IDeviceNode;

    @Input() public displayCount: number;

    @Input() public setDeviceInfo: (deviceInfo: DeviceInformation) => void;

    @Input() public hideTitle = false;

    @ViewChild(DeviceInputHostDirective, { static: true }) public deviceInputHost: DeviceInputHostDirective;

    private component: DynamicInputComponent;
    private oldDisplayCount: number;

    constructor(
        private dynamicComponentService: DynamicComponentService
    ) {
    }

    public ngAfterContentInit() {
        let componentName = this.deviceInputTemplate || this.deviceInput.$inputType;
        let factory = this.dynamicComponentService.resolveComponent(componentName);

        const viewContainerRef = this.deviceInputHost.viewContainerRef;
        viewContainerRef.clear();

        this.component = viewContainerRef.createComponent(factory).instance as DynamicInputComponent;
        this.updateComponent();
        this.oldDisplayCount = this.displayCount;

        let deviceInputComponent = this.component as unknown as IDeviceInputComponent;

        if (deviceInputComponent.hasDeviceInput) {
            deviceInputComponent.deviceInput = this.deviceInput;
        }

        if (this.deviceInput.hoverInfo && this.deviceInput.isVisible) {
            let hoverInfoFactory = this.dynamicComponentService.resolveComponent(HoverInfoComponent.$name);

            if (!hoverInfoFactory) {
                return;
            }

            let hoverInfoComponent = viewContainerRef.createComponent(hoverInfoFactory).instance as HoverInfoComponent;
            hoverInfoComponent.hoverInfo = this.deviceInput.hoverInfo;
        }
    }

    public ngDoCheck(): void {
        if (this.displayCount && this.displayCount !== this.oldDisplayCount && this.component && this.deviceInput) {
            this.oldDisplayCount = this.displayCount;
            this.updateComponent();
        }
    }

    private updateComponent() {
        this.component.deviceInfo = this.deviceInfo;
        this.component.displayCount = this.displayCount;
        this.component.groupSections = this.deviceInput;
        this.component.deviceInputForm = this.deviceInputForm;
        this.component.setDeviceInfo = this.setDeviceInfo;
        this.component.hideTitle = this.hideTitle;
    }
}
